import React from 'react';
import { Breadcrumb, Layout } from 'antd';
import { Link } from 'react-router-dom';
import AffiliateCreate from './components/AffiliateCreate';

const BreadcrumbItem = Breadcrumb.Item;
const breadcrumb_position = { margin: '0 0 1% 0' };
const layout_position = { padding: '0 5%' };

export default function Index() {
    return (
        <Layout style={layout_position}>
            <Breadcrumb style={breadcrumb_position}>
                <BreadcrumbItem><Link to="/PlatformManagement/Manage_affiliates">Manage Affiliates</Link></BreadcrumbItem>
                <BreadcrumbItem>Add Affiliate</BreadcrumbItem>
            </Breadcrumb>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <h3 className="page-title">Add Affiliate</h3>
                    <h3 className="page-subhead subhead">Complete the details below to create a new affiliate within the SuperBike Factory platform.</h3>
                </div>
            </div>
            <AffiliateCreate />
        </Layout>
    );
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/index.js